// The reason for this separate file is so that we only load the aws-sdk lib when absolutely
// necessary as it's rather large.
import {
  CognitoIdentityProvider,
  ConfirmForgotPasswordResponse,
  ForgotPasswordResponse,
  ForgotPasswordRequest,
} from '@aws-sdk/client-cognito-identity-provider';

import { COGNITO_CLIENT_ID } from '@config/cognito';

const cognitoProvider = new CognitoIdentityProvider({
  region: 'eu-west-1',
});

export const resetPassword = async (email: string): Promise<ForgotPasswordResponse> => {
  const params: ForgotPasswordRequest = {
    ClientId: COGNITO_CLIENT_ID,
    Username: email,
  };
  return cognitoProvider.forgotPassword(params);
};

export const newPasswordFromReset = async (
  username: string,
  code: string,
  password: string,
): Promise<ConfirmForgotPasswordResponse> => {
  const params = {
    ClientId: COGNITO_CLIENT_ID,
    Username: username,
    Password: password,
    ConfirmationCode: code,
  };
  return cognitoProvider.confirmForgotPassword(params);
};
